export default __webpack_public_path__ + "static/media/hani.fc3ffe83.jpg";